import {
  GET_FORMATTED_CITATIONSV2,
  GET_STYLES_V2,
} from '@chegg-wt/core/oneGraphQueries/FormattedCitations'
import { getActualStyleId, popularStyles } from '@chegg-wt/core/utils/styles'
import {
  GetFormattedCitationsV2,
  GetFormattedCitationsV2Variables,
} from '../oneGraphQueries/__generated__/GetFormattedCitationsV2'
import {
  GetCitationStylesV2,
  GetCitationStylesV2Variables,
} from '../oneGraphQueries/__generated__/GetCitationStylesV2'
import { client } from './graphApi'

export const oneGraph = {
  getCitationsV2: (variables: GetFormattedCitationsV2Variables) => {
    return client.query<GetFormattedCitationsV2>({
      query: GET_FORMATTED_CITATIONSV2,
      variables,
      context: {
        clientName: 'oneGraph',
      },
    })
  },
  getStylesV2: ({ keyword, page = 1 }: GetCitationStylesV2Variables) => {
    return client.query<GetCitationStylesV2>({
      query: GET_STYLES_V2,
      variables: {
        keyword,
        page,
      },
      context: {
        clientName: 'oneGraph',
      },
    })
  },
}

export const getUrlStyleNameV2 = async (style: string, page = 1) => {
  const actualStyleId = getActualStyleId(style)
  const pop = popularStyles[actualStyleId]
  if (pop) {
    return pop
  }
  try {
    const stylesV2Response = await oneGraph.getStylesV2({ keyword: actualStyleId, page })
    const { name } = stylesV2Response.data.citationStylesV2.results[0]
    return [name, name]
  } catch {
    const name = style.toUpperCase()
    return [name, name]
  }
}
